import { useEffect } from 'react'
import { useGetQuery } from 'hooks'
import { Card, Icon, Link, PaginateTable, Tag } from 'components'

export const AdminCategories = () => {
  const { data } = useGetQuery({ url: '/admin/categories' })
  useEffect(() => {
    console.log({ data })
  }, [data])

  const updatePage = (page) => {
    return page
  }
  if (!data) return <div>loading</div>
  return (
    <Card>
      <PaginateTable
        data={data?.categories?.rows || []}
        count={data?.categories?.count || 0}
        columns={[
          {
            title: 'Name',
            key: 'name'
          },
          {
            title: '',
            key: 'description'
          },
          {
            title: 'Actions',
            key: 'slug',
            className: 'right',
            render: (slug) => {
              return <Link to={`/admin/categories/${slug}`}>edit</Link>
            }
          }
        ]}
        onPageChange={updatePage}
        title="Categories"
      />
    </Card>
  )
}
